import {
  CapaPaymentMethodType,
  useFetchMyRefundBankAccountsQuery
} from '@generated/graphql';
import {
  CustomizedTypography,
  Stack,
  VStack,
  ConditionalRender
} from '@components/Customized';
import { ProgressInfoBottomItemCommonProps } from './types';
import { bankMap } from '@utils/bankMap';
import { maskingBankAccount } from '@utils/maskingString';

const RefundConfirmed: React.FunctionComponent<ProgressInfoBottomItemCommonProps> = ({
  payment
}) => {
  const { data: refundAccountData } = useFetchMyRefundBankAccountsQuery({
    fetchPolicy: 'network-only'
  });
  const refundAccountList = refundAccountData?.fetchMyRefundBankAccounts?.data;
  const refundAccount = refundAccountList?.[0];
  const isCard = payment?.paymentMethod === CapaPaymentMethodType.CreditCard;
  const cardCompany = isCard ? payment?.cardInfo?.cardName : undefined;
  const cardNumberSecret = isCard ? payment?.cardInfo?.cardNumber : undefined;
  const refundAccountHolderName = !isCard
    ? refundAccount?.holderName
    : undefined;
  const refundAccountBank = !isCard
    ? bankMap(refundAccount?.bankCode)
    : undefined;
  const refundAccountNumber = !isCard
    ? maskingBankAccount(refundAccount?.account)
    : undefined;
  const refundAmount = (payment?.totalAmount ?? 0).toLocaleString('kr');

  return (
    <Stack alignItems="center" justifyContent="space-between">
      <ConditionalRender visible={isCard}>
        <VStack justifyContent="center">
          <CustomizedTypography
            variant="body2"
            fontWeight="500"
            color="textPrimary"
          >
            신용카드
          </CustomizedTypography>
          <Stack>
            <CustomizedTypography variant="body2" color="textPrimary">
              {cardCompany}
            </CustomizedTypography>
            <CustomizedTypography variant="body2" color="textSecondary">
              ({cardNumberSecret})
            </CustomizedTypography>
          </Stack>
        </VStack>
      </ConditionalRender>

      <ConditionalRender visible={!isCard}>
        <VStack justifyContent="center">
          <CustomizedTypography
            variant="body2"
            fontWeight="500"
            color="textPrimary"
          >
            {refundAccountHolderName}
          </CustomizedTypography>
          <Stack gap={2}>
            <CustomizedTypography variant="body2" color="textPrimary">
              {refundAccountBank}
            </CustomizedTypography>
            <CustomizedTypography variant="body2" color="textSecondary">
              {refundAccountNumber}
            </CustomizedTypography>
          </Stack>
        </VStack>
      </ConditionalRender>

      <VStack justifyContent="center">
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          총 환불금액
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="500"
          align="right"
        >
          {refundAmount}원
        </CustomizedTypography>
      </VStack>
    </Stack>
  );
};

export default RefundConfirmed;
